export const ROUTES = {
    orders: '/',
    order_acceptance: '/order',
    settings: '/settings',
    login: '/login',
    registration: '/registration'

}